import Vue from 'vue';
import router from './router';
import store from './store';
import { ApiService } from '@/services/api.service';
import VuePageTransition from 'vue-page-transition';
import VueMask from 'v-mask';
import VueCookies from 'vue-cookies';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import Loading from './plugins/loading';
import Notifier from './plugins/notifier';
import Confirm from './plugins/confirm';
import ReasonPrompt from './plugins/reason-prompt';
import LfPlugin from '@/plugins/lf.plugin';
import i18n from '@/i18n/config';
import ValidatorsPlugin from '@/plugins/validators.plugin';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import {
  ArcElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {VPerfectSignature} from 'v-perfect-signature';
import pdf from 'vue-pdf';
import '@/assets/styles/main.scss';
import OnceDialog from '@/plugins/once-dialog';
import PreviewGallery from '@/plugins/preview-gallery';

Vue.config.productionTip = false;

Vue.use(VuePageTransition);
Vue.use(Loading);
Vue.use(Notifier);
Vue.use(Confirm);
Vue.use(ReasonPrompt);
Vue.use(OnceDialog);
Vue.use(PreviewGallery);
Vue.use(VueMask);
Vue.use(VueCookies);
Vue.use(LfPlugin);
Vue.use(ValidatorsPlugin);
Vue.use(VPerfectSignature);
Vue.use(pdf);

ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, ArcElement, PointElement, ChartDataLabels);

ApiService.configureAxios();

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: 'https://e9db2ad37d60c57dc21d5ad0c63020e1@o4504286306172928.ingest.us.sentry.io/4508092637446144',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: ['test-portal.ravapi.eu', 'portal.ravapi.eu', /^\//],
      }),
    ],
    tracesSampleRate: 1.0,
    // Signature devices poll the queue every 2 s; successful polls would push everything else out of the breadcrumb buffer.
    beforeBreadcrumb: (breadcrumb) => {
      const isSuccessfulQueuePoll = breadcrumb.category === 'xhr'
        && breadcrumb.data?.url?.includes('GetCurrentIdFromQueue')
        && breadcrumb.data?.status_code === 200;

      return isSuccessfulQueuePoll ? null : breadcrumb;
    },
  });
}

// installGtag(process.env.VUE_APP_GTAG_ID || 'unknown')


new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');


function installGtag(id: string) {
  const gtag = document.getElementById('gtag-script');

  if (gtag) {
    gtag.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${id}');`
  }

}
